import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import {
  BreakPointDesktop,
  BreakPointMobile,
  BreakPointTablet,
} from "../../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    position: "relative",
    width: "-webkit-fill-available",
    display: "-webkit-box",
    cursor: "pointer",
    borderRadius: theme.radius.large,
    boxSizing: "border-box",
    [BreakPointTablet]: {
      height: 402,
      paddingBottom: 0,
    },
    [BreakPointMobile]: {
      height: 360,
      paddingBottom: 0,
    },
    [BreakPointDesktop]: {
      "&:hover": {
        transform: "scale(1.02)",
      },
    },
  },
  featuredImg: {
    objectFit: "cover",
    width: "100%",
    position: "absolute",
    height: "100%",
    borderRadius: theme.radius.large,
  },
  content: {
    position: "absolute",
    width: "100%",
    height: "100%",
    padding: `${theme.spacing.space32}px ${theme.spacing.space24}px`,
    boxSizing: "border-box",
  },
  starImg: {
    height: 24,
    width: 24,
  },
  ftLogo: {
    position: "absolute",
    bottom: theme.spacing.space12,
    right: theme.spacing.space16,
    "@media(max-width: 480px)": {
      width: 200,
    },
  },
  selected: {
    outline: "2px solid rgba(255, 255, 255, 0.80)",
    outlineOffset: 2,
  },
  desc: {
    marginTop: theme.spacing.space8,
  },
  btnAction: {
    position: "absolute",
    bottom: theme.spacing.space32,
    right: theme.spacing.space24,
    borderRadius: theme.radius.large,
  },
}));
